import React from "react";
import "./ErrorPopUp.css";
import { Modal } from "react-bootstrap";
import alert from "../../assets/images/packages/svg/error-icon.svg"
import { useTranslation } from "../../contexts/TranslationContext";


const ErrorPopUp = ({ title = "Error", message, showpopUp, handleClose }) => {
    const { t } = useTranslation();
  
  return (
    <Modal show={showpopUp} onHide={handleClose} centered className="error-modal">
      <Modal.Body className="error-modal-body">
        <div className="icon-wrapper">
          <img src={alert} />
        </div>
        <div className="title">{title}</div>
        <p className="subtitle">{message}</p>
        <button className="btn-ok" onClick={handleClose}>{t("Ok")}</button>

      </Modal.Body>
    </Modal>
  );
};

export default ErrorPopUp;